export default "__VITE_ASSET__BJLi5LXW__"